import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '@/api/auth';
import { useAuthStore } from '@/store/authStore';
import styles from './LoginPage.module.css';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const setSession = useAuthStore((s) => s.setSession);
  const navigate = useNavigate();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await login(email.trim().toLowerCase(), password);
      setSession(res.token, res.user);
      navigate(res.user.mustChangePassword ? '/cambiar-password' : '/');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Credenciales inválidas o error de conexión.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.shell}>
      <form className={styles.card} onSubmit={submit}>
        <div className={styles.brand}>
          <div className={styles.logo}>N</div>
          <div className={styles.brandText}>
            <div className={styles.brandTitle}>Deploy Management</div>
            <div className={styles.brandSub}>Nidatech · Implementaciones</div>
          </div>
        </div>

        <label className={styles.label}>
          <span>Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="tu@nidatech.ai"
            required
            autoFocus
            className={styles.input}
          />
        </label>

        <label className={styles.label}>
          <span>Contraseña</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
            className={styles.input}
          />
        </label>

        {error && <div className={styles.error}>{error}</div>}

        <button className={styles.submitBtn} type="submit" disabled={loading}>
          {loading ? 'Entrando…' : 'Entrar'}
        </button>

        <div className={styles.hint}>
          Si es tu primer acceso, te pediremos cambiar la contraseña.
        </div>
      </form>
    </div>
  );
}
